<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-row(no-gutters align="center")
        v-col(cols="10" offset="1")
          .text-md.font-semibold.text-center.neutral700--text Patient details
        v-col(cols="1" align="right")
          v-btn(icon @click="closeDialog" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.pa-6
      div.text-sm.font-medium.neutral700--text Search existing patient
      search-patient-dropdown.mt-2(v-model="objPatient" @change="onSelectExistingPatient")
      .py-4.text-center.font-semibold.neutral700--text OR
      v-row.pb-3
        v-col
          y-button(@click="showReaderDialog = true" label="Read from MyKad" color="neutral300" prepend-icon="$yzi-scan" block)
        v-col
          y-button(label="Add new patient" color="neutral300" prepend-icon="$yzi-user-plus-01" block @click="onAddNewPatient")

    .dialogs
      register-patient-dialog(v-if="openRegisterPatientDialog" :open.sync="openRegisterPatientDialog" :existing-patient.sync="patient" :purpose-data="type" :prefill-data="prefillData" @updated="onPatientCreated" @downgraded="handleDowngraded")
      my-kad-reader-dialog(v-if="showReaderDialog" :open.sync="showReaderDialog" @complete="processCardData")

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import SearchPatientDropdown from '@/components/clinic/registration/SearchPatientDropdown.vue'
import RegisterPatientDialog from '@/components/clinic/registration/RegisterPatientDialog.vue'
import MyKadReaderDialog from '@/components/clinic/registration/MyKadReaderDialog.vue'

export default {
  components: { SearchPatientDropdown, RegisterPatientDialog, MyKadReaderDialog },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'reservation'
    }
  },
  data: () => ({
    openRegisterPatientDialog: false,
    patient: null,
    objPatient: null,
    showReaderDialog: false,
    prefillData: null,
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    routeName () {
      return this.type === 'reservation' ? 'ClinicReservationNew' : 'ClinicPreorderNew'
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    onSelectExistingPatient () {
      if (this.objPatient) {
        this.navigateToDetail(this.objPatient.id)
      }
    },
    onAddNewPatient () {
      this.prefillData = null
      this.patient = null
      this.openRegisterPatientDialog = true
    },
    onPatientCreated () {
      if (this.patient) {
        this.navigateToDetail(this.patient)
      }
    },
    processCardData (data) {
      if (data.id) {
        this.navigateToDetail(data.id)
      } else {
        this.prefillData = data
        this.patient = null
        this.openRegisterPatientDialog = true
      }
    },
    navigateToDetail (patientId) {
      this.showDialog = false
      this.$router.push({ name: this.routeName, params: { patientId: String(patientId) } })
    },
    closeDialog () {
      this.showDialog = false
    },
    handleDowngraded () {
      this.openRegisterPatientDialog = false
    }
  }
}
</script>
